import React from 'react';
import {Chip} from '@mui/material';
import {CustomerMemberShipNames} from '../../../../../../../core/constants/enums';

/**
 * Semantic colors for membership statuses (MUI Chip color + theme palette path for dots).
 */
export const membershipStatusColors = {
    all: {
        chip: 'default',
        dot: 'grey.500',
    },
    [CustomerMemberShipNames.active]: {
        chip: 'success',
        dot: 'success.main',
    },
    [CustomerMemberShipNames.onHold]: {
        chip: 'warning',
        dot: 'warning.main',
    },
    [CustomerMemberShipNames.deactivated]: {
        chip: 'error',
        dot: 'error.main',
    },
    [CustomerMemberShipNames.onHoldCompanyLost]: {
        chip: 'info',
        dot: 'info.main',
    },
    generic: {
        chip: 'default',
        dot: 'grey.500',
    },
};

/**
 * Resolves chip/dot colors for a membership status or tab value.
 * @param {string | null | undefined} statusOrTab
 * @returns {{chip: string, dot: string}}
 */
export const resolveMembershipStatusColor = (statusOrTab) =>
    membershipStatusColors[statusOrTab] ?? membershipStatusColors.generic;

/**
 * Colored status chip for member rows and related UI.
 * @param {object} props
 * @param {string} props.label
 * @param {string} [props.status]
 * @param {'small' | 'medium'} [props.size]
 */
const MembershipStatusChip = ({label, status, size = 'small'}) => {
    const {chip} = resolveMembershipStatusColor(status);

    if (!label) {
        return null;
    }

    return (
        <Chip
            size={size}
            label={label}
            color={chip}
            variant="filled"
            sx={{
                fontWeight: 600,
                maxWidth: '100%',
                '& .MuiChip-label': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            }}
        />
    );
};

export default MembershipStatusChip;
